import { useEffect } from "react";
import { Box } from "@mui/material";
import Base from "../../Base/views/Base";
import CanteenRegionConfig from "./CanteenRegion/CanteenRegionConfig";

const CanteenSetting = () => {
  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Base>
      <Box sx={{ height: "calc(100vh - 65px)", overflowY: "auto" }}>
        <CanteenRegionConfig />
      </Box>
    </Base>
  );
};

export default CanteenSetting;
